<template>
    <div class="bg-white p-3 radius-8 mt-3">
        <div class="row g-3">
            <template v-for="(checkbox, cIndex) in service.service_checkbox" :key="cIndex">
                <div class="col-12" v-if="checkbox.checkbox_value === 'verificationScop'">
                    <div class="form-group">
                        <label class="text-18" for="date">Verification Scope</label>
                        <div class="row g-3">
                            <div class="col-lg-4 col-sm-6" v-for="(item, index) in checkbox.children" :key="index">
                                <div class="form-check p-3 radius-8 bg-color w-100">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="responses.checkboxes[item.checkbox_value]"
                                        :id="`slcp-${cIndex}-${index}`"
                                    />
                                    <label
                                        class="form-check-label text-16 fw-normal lh-1 m-0 w-100"
                                        :for="`slcp-${cIndex}-${index}`"
                                    >
                                        {{ item.checkbox_value ?? '' }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12" v-if="checkbox.checkbox_value === 'verificationCheckboxes'">
                    <div class="form-group">
                        <label class="text-18" for="date">Type of Verification</label>
                        <div class="d-flex align-items-center gap-3 flex-sm-row flex-column">
                            <div class="form-check p-3 radius-8 bg-color w-100" v-for="(item, index) in checkbox.children" :key="index">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="responses.checkboxes[item.checkbox_value]"
                                    :id="`slcp-type-${cIndex}-${index}`"
                                />
                                <label class="form-check-label text-16 fw-normal lh-1 m-0 w-100" :for="`slcp-type-${cIndex}-${index}`">
                                    {{ item.checkbox_value ?? '' }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

            </template>

            <!-- Dynamic service inputs -->
            <div class="col-lg-6 col-md-6" v-for="(input, index) in service.service_input" :key="index">
                <div class="form-group">
                    <label class="text-18">{{ input.input_value }}</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="responses.inputs[input.input_value]"
                        :placeholder="`Enter ${input.input_value}`"
                    />
                </div>
            </div>

            <!-- Dynamic service dates -->
            <div class="col-lg-6 col-md-6" v-for="(date, index) in service.service_date" :key="index">
                <div class="form-group">
                    <label class="text-18">{{ date.date_value }}</label>
                    <input
                        type="date"
                        class="form-control"
                        v-model="responses.dates[date.date_value]"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    service: Object,
    responses: Object
})
</script>
